import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './components/app';
import { HelmetProvider } from 'react-helmet-async';
import { ErrorBoundary } from './components/app/ErrorBoundary';
import { registerGlobalErrorHandlers } from './components/app/globalErrorHandlers';
import { initCrossTabAccountSwitchReload } from './client/tokenStorage';

// Catch async errors / promise rejections that never reach a React boundary.
// Idempotent, so StrictMode's double-invoke can't attach duplicate listeners.
registerGlobalErrorHandlers();

// TCX-824: reload this tab when another tab signs in as a DIFFERENT account,
// so a stale tab can't send clicks under the new account's token. Idempotent.
initCrossTabAccountSwitchReload();

const rootElement = document.querySelector('#root') as HTMLElement;


createRoot(rootElement).render(
  <StrictMode>
    <ErrorBoundary>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </ErrorBoundary>
  </StrictMode>,
);
